import { createLazyComponent } from '@muse-web/router'

export const AsyncDeleteCollectionDialogContainer = createLazyComponent(
    () =>
        import(
            /* webpackChunkName: 'dialog-delete-collection' */ './DeleteCollectionDialogContainer'
        ),
    'DeleteCollectionDialogContainer',
)
